// extracted by mini-css-extract-plugin
module.exports = {"Auto":"auto_Auto__dGg7y"};